'use client'
import Script from 'next/script'
import { RECAPTCHA_SCORE_URL, RECAPTCHA_CHECKBOX_URL } from './utils'

export function CheckboxLoader() {
	return <Script src={RECAPTCHA_CHECKBOX_URL} async defer />
}

export function InvisibleLoader() {
	return <Script src={RECAPTCHA_SCORE_URL} async />
}
